import React from 'react';
import './TodayProfitModal.css';
import dateUtils from '../../utils/dateUtils';


const TodayProfitModal = ({ isOpen, onClose, profitData }) => {
  if (!isOpen) return null;

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    }).format(amount);
  };

  const hasData = profitData && profitData.items && profitData.items.length > 0;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="today-profit-modal" onClick={(e) => e.stopPropagation()}>
        <div className="today-profit-header">
          <h2>💰 Today's Profit Summary</h2>
          <button className="today-profit-close" onClick={onClose}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div className="today-profit-content">
          {/* Summary Cards */}
          <div className="profit-summary-cards">
            <div className="profit-card revenue">
              <div className="profit-card-icon">💵</div>
              <div className="profit-card-info">
                <span className="profit-card-label">Total Revenue</span>
                <span className="profit-card-value">
                  {profitData ? formatCurrency(profitData.totalRevenue) : '$0.00'}
                </span>
              </div>
            </div>

            <div className="profit-card cost">
              <div className="profit-card-icon">📊</div>
              <div className="profit-card-info">
                <span className="profit-card-label">Total Cost</span>
                <span className="profit-card-value">
                  {profitData ? formatCurrency(profitData.totalCost) : '$0.00'}
                </span>
              </div>
            </div>

            <div className="profit-card profit">
              <div className="profit-card-icon">🎯</div>
              <div className="profit-card-info">
                <span className="profit-card-label">Net Profit</span>
                <span className="profit-card-value">
                  {profitData ? formatCurrency(profitData.totalProfit) : '$0.00'}
                </span>
              </div>
            </div>

            <div className="profit-card transactions">
              <div className="profit-card-icon">🧾</div>
              <div className="profit-card-info">
                <span className="profit-card-label">Transactions</span>
                <span className="profit-card-value">
                  {profitData ? profitData.totalTransactions : 0}
                </span>
              </div>
            </div>
          </div>

          {/* Date Display */}
          <div className="profit-date">
            <span>📅 {profitData ? profitData.date : dateUtils.formatDate(new Date())}</span>
          </div>

          {/* Transactions List */}
          <div className="profit-list-section">
            <h3>Transaction Details</h3>
            {profitData?.error ? (
              <div className="profit-error">{profitData.error}</div>
            ) : hasData ? (
              <div className="profit-list-container">
                <table className="profit-list-table">
                  <thead>
                    <tr>
                      <th>Invoice</th>
                      <th>Customer</th>
                      <th>Time</th>
                      <th>Revenue</th>
                      <th>Cost</th>
                      <th>Profit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {profitData.items.map((item, index) => (
                      <tr key={item.id || index} className={item.profit >= 0 ? 'positive' : 'negative'}>
                        <td className="invoice-cell">#{item.invoiceNo}</td>
                        <td className="customer-cell">{item.customer}</td>
                        <td className="time-cell">{item.time}</td>
                        <td className="amount-cell revenue">{formatCurrency(item.revenue)}</td>
                        <td className="amount-cell cost">{formatCurrency(item.cost)}</td>
                        <td className={`amount-cell profit ${item.profit >= 0 ? 'positive' : 'negative'}`}>
                          {formatCurrency(item.profit)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="profit-empty">
                <div className="profit-empty-icon">📭</div>
                <p>No transactions found for today</p>
                <span>Start making sales to see your profit data here</span>
              </div>
            )}
          </div>
        </div>

        <div className="today-profit-footer">
          <button className="today-profit-btn-close" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default TodayProfitModal;
